import IndexPage from "../page/context/IndexPage";
import CompanyPage from "../page/context/CompanyPage";
import ProductsPage from "../page/context/ProductsPage";
import AboutUsPage from "../page/context/AboutUsPage";
import ConcatUsPage from "../page/context/ConcatUsPage";
import WarehousePage from "../page/context/WarehousePage";
import ECommencePage from "../page/context/ECommencePage";
import OurBusinessPage from "../page/context/OurBusinessPage";
import DigitalPlatFormPage from "../page/context/DigitalPlatFormPage";

const routes = [
    {
        path: "/index",
        exact: false,
        name: "首页",
        disabled:true,
        component: IndexPage
    }, {
        path: "/company",
        exact: false,
        name: "Company",
        component: CompanyPage
    }, {
        path: "/products",
        exact: false,
        name: "Products",
        component: ProductsPage
    },  {
        path: "/eCommence",
        exact: false,
        name: "E-commence Solution",
        component: ECommencePage
    },{
        path: "/aboutUs",
        exact: false,
        name: "About Us",
        component: AboutUsPage
    }, {
        path: "/concatUs",
        exact: false,
        name: "Concat",
        disabled:true,
        component: ConcatUsPage
    }, {
        path: "/warehouse",
        exact: false,
        name: "WarehousePage",
        disabled:true,
        component: WarehousePage
    }, {
        path: "/ourBusiness",
        exact: false,
        name: "OurBusinessPage",
        disabled:true,
        component: OurBusinessPage
    }, {
        path: "/digitalPlatForm",
        exact: false,
        name: "DigitalPlatFormPage",
        disabled:true,
        component: DigitalPlatFormPage
    }
]

export default routes
